import React from 'react';
import { useNavigate } from 'react-router-dom';
import useAuthStore from '../store/authStore';
import { FaUser, FaBell, FaCog } from 'react-icons/fa';
import './Dashboard.css';

function Dashboard() {
  const navigate = useNavigate();
  const { user } = useAuthStore();

  return (
    <div className="dashboard-container">
      <h1>Welcome, {user?.email}!</h1>
      <p className="subtitle">Your ISP Email Policy Update Monitor</p>

      <div className="dashboard-grid">
        <div className="dashboard-card" onClick={() => navigate('/updates')}>
          <div className="card-icon">📧</div>
          <h2>Latest Updates</h2>
          <p>View the most recent ISP policy changes</p>
        </div>

        <div className="dashboard-card" onClick={() => navigate('/digest')}>
          <div className="card-icon">📋</div>
          <h2>Digest</h2>
          <p>Read your curated weekly digest</p>
        </div>

        <div className="dashboard-card" onClick={() => navigate('/profile')}>
          <div className="card-icon">⚙️</div>
          <h2>Preferences</h2>
          <p>Manage your notification settings</p>
        </div>

        {user?.is_admin && (
          <div className="dashboard-card" onClick={() => navigate('/admin')}>
            <div className="card-icon">👨‍💼</div>
            <h2>Admin Panel</h2>
            <p>Review and manage all updates</p>
          </div>
        )}
      </div>

      <div className="dashboard-info">
        <h2>What This Service Does</h2>
        <ul>
          <li>📡 Monitors Gmail, Yahoo, Outlook, BIMI, and DMARC policy updates</li>
          <li>🔍 Filters and classifies updates by relevance</li>
          <li>📊 Provides weekly digests of important changes</li>
          <li>⚡ Alerts you to critical authentication and deliverability issues</li>
          <li>💾 Maintains historical records of all ISP policy changes</li>
        </ul>
      </div>
    </div>
  );
}

export default Dashboard;
